import React from 'react';
import { Optional } from 'utility-types';

import { Legends, VerticalBarChart } from 'modules/experience-core';
import { OrderType, PerformanceBarChartData } from 'modules/insights-v2/types';

type PerformanceBarChartProps = {
  data: PerformanceBarChartData;
  isBarStacked: boolean;
  currency?: Currency;
  summaryKey: string;
  legends: Optional<Legends<OrderType>, OrderType.WoltPlus>;
};

const PerformanceBarChart = ({ data, isBarStacked, currency, legends, summaryKey }: PerformanceBarChartProps) => (
  <VerticalBarChart
    data={data}
    isStacked={isBarStacked}
    currency={currency}
    legends={legends}
    summaryKey={summaryKey}
  />
);
export default PerformanceBarChart;
